import React, { useCallback } from 'react';
import 'react-quill/dist/quill.snow.css';
import { formats, modules } from './constants';
import { ReactQuillStyled } from './NoticeStoreEditor.style';

interface INoticeStoreEditorProps {
  content: string;
  setData: ({ path, value }: { path: string[]; value: string }) => void;
}

const NoticeStoreEditor = (props: INoticeStoreEditorProps): JSX.Element => {
  const { content, setData } = props;

  const handleEditorChange = useCallback((html: string) => {
    setData({
      path: ['noticeStore', 'noticeStoreInfo', 'content'],
      value: html,
    });
  }, []);

  return <ReactQuillStyled value={content} onChange={handleEditorChange} modules={modules} formats={formats} />;
};

export default NoticeStoreEditor;
